import { IMutationOptions, useMutation } from '@/lib/datx-jsonapi-react';
import { createUserSession } from '@/mutations/sessions';
import { Session, SessionDocument } from '@/resources/Session';

export function useLoginMutation(options?: IMutationOptions<SessionDocument, Session>) {
  return useMutation<SessionDocument, Session>(createUserSession, options);
}
